import novios from './images/novios.png';
import pets from './images/pets.png';
import fitness from './images/fitness.png';
import school from './images/school.png';
import mom from './images/mom.png';
import kids from './images/kids.png';
import home from './images/home.png';

import RNovios from './images/Rnovios.svg';
import RPets from './images/Rpets.svg';
import RFitness from './images/RFitness.svg';
import RSchool from './images/Rschool.svg';
import RMom from './images/Rmom.svg';
import RKids from './images/Rkids.svg';
import RHome from './images/Rhome.svg';

export const clubs = [
  {
    name: 'Novios',
    image: novios,
    rImage: RNovios,
    link: 'https://novios.ripley.cl/club/novios/index.html',
  },
  {
    name: 'Home',
    image: home,
    rImage: RHome,
    link: 'https://decohogar.ripley.cl/club/deco/index.html',
  },
  {
    name: 'Mom',
    image: mom,
    rImage: RMom,
    link: 'https://mama.ripley.cl/club/mama/index.html',
  },
  {
    name: 'Kids',
    image: kids,
    rImage: RKids,
    link: 'https://kids.ripley.cl/club/kids/index.html',
  },
  {
    name: 'School',
    image: school,
    rImage: RSchool,
    link: 'https://viajes.ripley.cl/club/viajes/index.html',
  },
  {
    name: 'Pet',
    image: pets,
    rImage: RPets,
    link: 'https://mascota.ripley.cl/club/mascota/index.html',
  },
  {
    name: 'Fitness',
    image: fitness,
    rImage: RFitness,
    link: 'https://fitness.ripley.cl/club/fitness/index.html',
  },
];
